import { render } from "./CategoryFieldsetGroup.vue?vue&type=template&id=44feb448"
import script from "./CategoryFieldsetGroup.vue?vue&type=script&lang=js"
export * from "./CategoryFieldsetGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__